// extracted by mini-css-extract-plugin
export default {"listMain":"ListMain_listMain__XT3Ty","createBtnWrap":"ListMain_createBtnWrap__37TN2","rollingPaperTitle":"ListMain_rollingPaperTitle__udiq2","createBtn":"ListMain_createBtn__9H+iq"};